import { Box, Chip, Stack, Typography } from "@mui/material";
import GlassCard from "../dashboard/GlassCard";
import DataModeBadge from "./DataModeBadge";
import { useTranslation } from "react-i18next";

const EvidenceViewer = ({ item }) => {
  const { t } = useTranslation();
  return (
    <GlassCard hover={false} sx={{ height: "100%" }}>
      <Stack spacing={1.5}>
        <Box sx={{ aspectRatio: "16 / 9", bgcolor: "#020617", borderRadius: 1, display: "grid", placeItems: "center" }}>
          <Typography color="rgba(226,232,240,0.72)">{item.type === "video" ? t("platform.evidence.video") : t("platform.evidence.thumbnail")}</Typography>
        </Box>
        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1}>
          <Box>
            <Typography variant="h5">{item.id}</Typography>
            <Typography variant="body2" color="text.secondary">{item.incidentId} · {item.cameraId}</Typography>
          </Box>
          <DataModeBadge mode={item.dataMode || "mock"} />
        </Stack>
        <Stack direction="row" spacing={1} flexWrap="wrap">
          <Chip size="small" label={item.store} variant="outlined" />
          <Chip size="small" label={`${Math.round(Number(item.confidence || 0) * 100)}%`} variant="outlined" />
        </Stack>
      </Stack>
    </GlassCard>
  );
};

export default EvidenceViewer;
